
    // recupere url
    var currentP = window.location.origin;
    // force language
    if(locallang === undefined)
    {
        locallang ='fr';
    }
    tarteaucitronForceLanguage = locallang;

    tarteaucitron.init({
        "privacyUrl": currentP + '/rgpd/privacy-policy', /* Privacy policy url */

        "hashtag": "#tarteaucitron", /* Open the panel with this hashtag */
        "cookieName": "tarteaucitron", /* Cookie name */

        "orientation": "bottom", /* Banner position (top - bottom - middle - popup) */

        "groupServices": false, /* Group services by category */

        "showAlertSmall": false, /* Show the small banner on bottom right */
        "cookieslist": false, /* Show the cookie list */

        "showIcon": false, /* Show cookie icon to manage cookies */
        "iconSrc": "", /* Optionnal: URL or base64 encoded image */
        "iconPosition": "BottomRight", /* Position of the icon between BottomRight, BottomLeft, TopRight and TopLeft */

        "adblocker": false, /* Show a Warning if an adblocker is detected */

        "DenyAllCta": true, /* Show the deny all button */
        "AcceptAllCta": true, /* Show the accept all button when highPrivacy on */
        "highPrivacy": true, /* HIGHLY RECOMMANDED Disable auto consent */

        "handleBrowserDNTRequest": false, /* If Do Not Track == 1, disallow all */

        "removeCredit": true, /* Remove credit link */
        "moreInfoLink": true, /* Show more info link */
        "useExternalCss": false, /* If false, the tarteaucitron.css file will be loaded */

        "cookieDomain": domain, /* Shared cookie for subdomain website */

        "readmoreLink": "", /* Change the default readmore link pointing to tarteaucitron.io */

        "mandatory": true /* Show a message about mandatory cookies */
    });

        $("#tarteaucitronO").on("click", function(e){
        e.preventDefault();
        tarteaucitron.userInterface.openPanel();
    });


    // on est obligé de faire ca apres linit sinon ca marche pas !
    window.cookiesR =  tarteaucitron.cookie.read();
    /*Active le datalayer et el GOOGLE SI LUSER A ACTIONN2 LE SERVICE  */
    if(cookiesR.indexOf( 'googleadwordsconversion'+ '=true') >= 0 )
    {
        tarteaucitron.addScript('https://www.googletagmanager.com/gtag/js?id=AW-859099018');
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-859099018');
    }

    /*Permet l'envoi de data dans le datalayer pr google si le googleadwords convsion est on depuis contact form estimate et sell agency */

    window.gtag_report_conversion = function (url, sendTo)
    {
        if (cookiesR.indexOf('googleadwordsconversion' + '=true') >= 0) {

            gtag('event', 'conversion', {
                'send_to': sendTo,
                'event_callback': url
            });
        }
        return false;
    }










